import axios from '../../config/axios';


const apiTopup = async (data) => {
  try {
    const result = await axios.post(`/app/payment/qrcode_pay`,data,{headers: {
      Authorization: "Bearer " + localStorage.getItem("rondori_token"),
    }})
    return result && result.data
  } catch (error) {
    return error && error.response && error.response.data
  }
}

const apiTopupRedirect = async (data) => {
  try {
    const result = await axios.post(`/app/payment/redirect_pay`,data,{headers: {
      Authorization: "Bearer " + localStorage.getItem("rondori_token"),
    }})
    return result && result.data
  } catch (error) {
    return error && error.response && error.response.data
  }
}



export {
  apiTopup,
  apiTopupRedirect
}